import DefaultRenderer from './DefaultRenderer'
import VideoRenderer from './VideoRenderer'
export const renderers = [VideoRenderer, DefaultRenderer]
